import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { TokenStorageService } from '@core/services/token-storage.service';
import { RespondentTokenStorageService } from '@core/services/respondent-token-storage.service';

const PUBLIC_API_PATHS = [
  '/auth/',
  '/plans/available',
  '/api/my-forms/auth/email/',
  '/api/my-forms/auth/exchange-ticket',
  '/api/my-forms/auth/refresh',
  '/api/my-forms/auth/google',
  '/api/public/short-links/',
  '/api/public/forms/',
];

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const isPublic = PUBLIC_API_PATHS.some((path) => req.url.includes(path));
  if (isPublic) {
    return next(req);
  }

  // Keep caller-supplied Authorization (e.g. respondent / form-access on storage uploads).
  if (req.headers.has('Authorization')) {
    return next(req);
  }

  const isMyForms = req.url.includes('/api/my-forms/');
  const token = isMyForms
    ? inject(RespondentTokenStorageService).getAccessToken()
    : inject(TokenStorageService).getAccessToken();

  if (!token) {
    return next(req);
  }

  return next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
};
